/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Sources_SubtitleInputs */

const es_home_sources_subtitle = /** @type {(inputs: Home_Sources_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conecta tus herramientas favoritas y empieza a unificar tu conocimiento empresarial en segundos.`)
};

const en_home_sources_subtitle = /** @type {(inputs: Home_Sources_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect your favorite tools and start unifying your enterprise knowledge in seconds.`)
};

/**
* | output |
* | --- |
* | "Connect your favorite tools and start unifying your enterprise knowledge in seconds." |
*
* @param {Home_Sources_SubtitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const home_sources_subtitle = /** @type {((inputs?: Home_Sources_SubtitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Sources_SubtitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_sources_subtitle(inputs)
	return en_home_sources_subtitle(inputs)
});
export { home_sources_subtitle as "home.sources.subtitle" }